export const languages = ["en"];

export type Lang = "en"; // add more languages as needed

export type Agent = {
  vapiId: string;
};

export const agents: Record<Lang, Agent> = {
  en: {
    vapiId: process.env.NEXT_PUBLIC_SUNWAY_INTGEN_SALES_AGENT!,
  },
};
